/* eslint-disable
    import/no-mutable-exports,
    no-var
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import $ from 'jquery';

import {assert} from 'Asserts';
import * as benchlingUtil from 'BenchlingUtil';
import * as context from 'Context';
import * as FileBrowserDAO from 'file-browser/FileBrowserDAO';
import AppDispatcher from 'lib/Dispatcher';
import * as EventConstants from 'constants/EventConstants';
import notifications from 'notifications';
import ProtocolDAO from 'notebook/protocols/dao/ProtocolDAO';
import EditorStore from 'notebook/protocols/stores/EditorStore';
import {ACTION_RESET_VERSION} from 'notebook/store/VersioningConstants';

var EditorActions = {
  async bulkFetchSummaries(protocolIds) {
    const {fileSummariesById} = await FileBrowserDAO.bulkFetchFileSummaries(protocolIds);
    return fileSummariesById;
  },

  print(protocolID) {
    const state = EditorStore.getEditorState(protocolID);
    const versionId = state.openVersionId;
    window.open(`view?versionId=${versionId}#print`, '_blank');
  },

  update(protocolID, op, {bumpVersion = true} = {}) {
    // Merge in the changes into the open protocol, client-side.
    AppDispatcher.dispatch({
      actionType: EventConstants.EDITOR_UPDATE,
      protocolID,
      op,
      cidIdMap: {},
      bumpVersion,
    });
  },

  postServerUpdate(protocolID, data) {
    AppDispatcher.dispatch({
      actionType: EventConstants.EDITOR_UPDATE,
      protocolID,
      op: {$merge: data},
      cidIdMap: {},
      bumpVersion: false,
    });
  },

  revert(protocolID, protocol, restoreData) {
    // Replace the open protocol with the specified data.
    // Useful to reset the state to an older state.
    AppDispatcher.dispatch({
      actionType: EventConstants.EDITOR_REPLACE,
      protocolID,
      protocol,
      restoreData,
    });
  },

  loadVersion(protocolID, versionId) {
    AppDispatcher.dispatch({
      actionType: EventConstants.EDITOR_LOAD_VERSION,
      protocolID,
      versionId,
    });
    ProtocolDAO.getVersion(protocolID, versionId)
      .done((response) => {
        AppDispatcher.dispatch({
          actionType: EventConstants.EDITOR_LOAD_VERSION_COMPLETED,
          protocolID,
          versionId,
          version: response,
        });
      })
      .fail((response) => {
        notifications.notifyError(response);
        AppDispatcher.dispatch({
          actionType: EventConstants.EDITOR_LOAD_VERSION_FAILED,
          protocolID,
          versionId,
        });
      });
  },

  fetchVersions(protocolID) {
    AppDispatcher.dispatch({
      actionType: EventConstants.EDITOR_FETCH_VERSIONS,
      protocolID,
    });
    ProtocolDAO.getVersions(protocolID)
      .done((response) => {
        AppDispatcher.dispatch({
          actionType: EventConstants.EDITOR_FETCH_VERSIONS_COMPLETED,
          protocolID,
          versions: response,
        });
      })
      .fail((response) => {
        AppDispatcher.dispatch({
          actionType: EventConstants.EDITOR_FETCH_VERSIONS_FAILED,
          protocolID,
        });
      });
  },

  resetToOpenVersion(protocolID) {
    const {isLatest} = EditorStore.getEditorState(protocolID);
    assert(!isLatest, 'Unexpected reset version while on latest version');
    context.using({immediateAutoSaverQueueSaveAction: ACTION_RESET_VERSION}, this, () => {
      AppDispatcher.dispatch({
        actionType: EventConstants.EDITOR_RESET_TO_OPEN_VERSION,
        protocolID,
      });
    });
  },

  save(protocolID) {
    // Create a deferred promise that will be resolved once the save has completed.
    const deferredPromise = $.Deferred();
    benchlingUtil.asyncThrottle(`protocol-save-${protocolID}`, () => {
      const {protocol, openVersion} = EditorStore.getEditorState(protocolID);

      // Avoid doing a save if the protocol is already up-to-date.
      if (!EditorStore.hasUnsavedChanges(protocolID)) {
        return deferredPromise.resolve(false).promise();
      }

      const serverProtocol = EditorStore.prepareForSave(protocolID, protocol);

      AppDispatcher.dispatch({
        actionType: EventConstants.EDITOR_SAVE,
        protocolID,
      });

      const xhr = ProtocolDAO.update(protocolID, serverProtocol)
        .done((response) => {
          AppDispatcher.dispatch(
            {
              actionType: EventConstants.EDITOR_SAVE_COMPLETED,
              protocolID,
              savedVersion: openVersion,
              versionId: response.cidIdMap[serverProtocol.cid],
              cidIdMap: response.cidIdMap,
              serverData: {
                editURL: response.editURL,
              },
            },
            EditorActions.fetchVersions(protocolID)
          );
          // Resolve the deferred promise to signal that the save has completed.
          deferredPromise.resolve(true);
        })
        .fail((response) => {
          notifications.stickyNotifyForFriendlyError(response, 'protocol-save-fail');
          AppDispatcher.dispatch({
            actionType: EventConstants.EDITOR_SAVE_FAILED,
            protocolID,
            error: response,
          });
          // Resolve the deferred promise to signal that the save has failed.
          deferredPromise.resolve(false);
        });
      return xhr;
    });
    // Return the deferred promise so that the caller can wait for the save to complete.
    return deferredPromise.promise();
  },

  // TODO(T1135): Don't pass in deferred. Note: Only ProxyFile should be passing in deferred.
  open(protocolID, param) {
    if (param == null) {
      param = {};
    }
    const {deferred} = param;
    AppDispatcher.dispatch({
      actionType: EventConstants.EDITOR_OPEN,
      protocolID,
    });
    ProtocolDAO.get(protocolID)
      .done((response) => {
        AppDispatcher.dispatch({
          actionType: EventConstants.EDITOR_OPEN_COMPLETED,
          protocolID,
          protocol: response,
        });
        EditorActions.fetchVersions(protocolID);
        if (deferred != null) {
          deferred.resolve();
        }
      })
      .fail((response) => {
        notifications.notifyError(response);
        AppDispatcher.dispatch({
          actionType: EventConstants.EDITOR_OPEN_FAILED,
          protocolID,
          error: response,
        });
        if (deferred != null) {
          deferred.reject(response);
        }
      });
  },

  close(protocolID) {
    AppDispatcher.dispatch({
      actionType: EventConstants.EDITOR_CLOSE,
      protocolID,
    });
  },
};

export default EditorActions;
